import { render, staticRenderFns } from "./TeamJoinedModal.vue?vue&type=template&id=53fe3490&scoped=true"
import script from "./TeamJoinedModal.vue?vue&type=script&lang=js"
export * from "./TeamJoinedModal.vue?vue&type=script&lang=js"
import style0 from "./TeamJoinedModal.vue?vue&type=style&index=0&id=53fe3490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe3490",
  null
  
)

export default component.exports